import Loading from '../../../../../components/Common/Loading'
import { Box } from '@mui/material'
import NoResults from '../../../../../components/Common/NoResults'
import Producto from '../Producto'
import NoSearch from '../../../../../components/Common/NoSearch'
import { useEffect, memo } from 'react'
import useRubros from '../../../../Products/hooks/rubros.hook'
import { PaginatorRes } from '../../../../Pedidos/context/pedidos.context'
import TablaServerPagination from '../../../../../components/Common/utils/paginator/serverPaginator'

interface CardProductosProps {
  productos: any[]
  paginator: PaginatorRes
  searching: boolean
  loadingProductos: boolean
  loadingVideo: boolean
}

const CardProductos = ({ productos, paginator, searching, loadingProductos, loadingVideo }: CardProductosProps) => {
  const { flatRubros: rubros, loading: loadingRubros } = useRubros()
  //const { items } = useSortableData(productos ? productos : []);
  useEffect(() => {
    // Scroll hacia arriba cuando cambia la página
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [paginator.pageNumber])

  if (loadingProductos) return <Loading />
  if (productos.length <= 0) {
    if (!searching) return <NoSearch items="productos" />
    return <NoResults />
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%'
      }}
    >
      <Box>
        <Box
          display="grid"
          sx={{
            gap: '20px',
            gridTemplateColumns: 'repeat(12, 1fr)',
            '@media (max-width: 750px)': {
              gridTemplateColumns: 'repeat(1, 1fr)'
            }
          }}
        >
          {productos.map((producto, i) => (
            <Box
              sx={{
                gridColumn: 'span 6',
                '@media (max-width: 750px)': {
                  gridColumn: 'span 12'
                }
              }}
              key={i}
            >
              <Producto
                key={i}
                producto={producto}
                rubros={rubros}
                loadingRubros={loadingRubros}
                loadingVideo={loadingVideo}
              />
            </Box>
          ))}
        </Box>
      </Box>

      <Box sx={{ alignSelf: 'end', margin: '20px 0px' }}>
        <TablaServerPagination component="div" label="Productos por página" paginator={paginator} />
      </Box>
    </Box>
  )
}

export default memo(CardProductos)
